<template>
  <view class="tabs">
    <view class="tabs-header" wx:class="{{ {'empty':tabsData?.length<=1} }}">
      <block wx:if="{{tabsData.length>1}}">
        <view
          wx:for="{{tabsData}}"
          wx:key="key"
          wx:class="tabs-header-item {{ currentTab === index ? 'active' : ''}}"
          bindtap="onTabClick(item, index)"
        ><text class="text">{{item.name}}</text></view>
      </block>
    </view>
    <view class="tabs-container" wx:style="{{tabTransformStyle}}">
      <view wx:for="{{tabContents}}" wx:key="key" class="tabs-container-item">
        <component is="{{item.comp}}" mixinShowProp="{{index === currentTab}}" />
      </view>
    </view>
  </view>
</template>

<script>
  import { createComponent } from '@mpxjs/core'

  createComponent({
    properties: {
      tabsData: {
        type: Array,
        value: () => ([])
      }
    },
    computed: {
      tabContents() {
        return this.tabsData.filter(({comp}) => comp)
      },
      tabTransformStyle() {
        return {
          transform: `translateX(-${this.currentTab * 100}%) translateY(-16px) translateZ(1px)`
        }
      }
    },
    created() {
      const default_idx = this.tabsData.findIndex(item => item.default)
      this.currentTab = default_idx>0 ? default_idx : 0
    },
    data: {
      currentTab: 0
    },
    methods: {
      onTabClick(tab, idx) {
        this.currentTab = tab.comp ? idx : this.currentTab
        this.triggerEvent('tabClick', {
          tab, idx
        })
      }
    }
  })
</script>

<style lang="stylus" scoped>
.tabs
  height auto
  overflow hidden
  &-header
    width calc(100% - 20px)
    margin-left 10px
    height 62px
    display flex
    align-items center
    padding-bottom 16px
    background-color #F2F6F9
    border-top-left-radius 16px
    border-top-right-radius 16px
    overflow hidden
    box-sizing border-box
    border 2px solid #fff
    border-bottom 0
    &.empty
      height 0
    &-item
      flex 1
      height 100%
      position relative
      @extend .flex-center
      justify-content center
      .text
        z-index 1
      &.active
        &::before, &::after
          content ''
          position absolute
          display block
        &::after
          bottom -16px
          width 100%
          height 16px
          background #fff
        &::before
          width calc(100% + 20px)
          height 100%
          background-image url('https://ut-static.udache.com/webx/sfc/TO6Yk4wEaXNAvow9Tx1TE.png')
          background-position center top
          background-repeat no-repeat
          background-size 100% 100%
        &:first-child
          &::before
            width calc(100% + 10px)
            background-image url('https://ut-static.udache.com/webx/sfc/ubGBzLUZ-S09L-Eb3wCBZ.png')
            left 0
        &:last-child
          &::before
            width calc(100% + 10px)
            background-image url('https://ut-static.udache.com/webx/sfc/oxGkIcQicqRvJ08wSOxGJ.png')
            right 0
  &-container
    width 100%
    height auto
    display flex
    transition-timing-function cubic-bezier(0.165, 0.84, 0.44, 1)
    transition-property transform
    transition-duration 300ms
    transform translateX(0) translateY(-16px) translateZ(1px)
    &-item
      box-sizing border-box
      overflow hidden
      width 100%
      flex none
</style>

<script name="json">
  module.exports = {
    usingComponents: {
      'train-home-comp': '../train-home/index',
      'flights-home-comp': '../flights-home/index',
    }
  }
</script>